/**
 * This file is a direct copy of functions from uPlot's opt.js and util.js files.
 * The only changes are to add type annotations for Typescript.
 *
 * https://github.com/leeoniya/uPlot/blob/master/src/opts.js
 * https://github.com/leeoniya/uPlot/blob/master/src/utils.js
 */

export const fixedDec = new Map();

const M = Math;

const ceil = M.ceil;
const isInt = Number.isInteger;

const regex6 = /\.\d*?(?=9{6,}|0{6,})/gm;

// e.g. 17999.204999999998 -> 17999.205
export const fixFloat = (val: number): number => {
  if (isInt(val) || fixedDec.has(val)) {
    return val;
  }

  const str = `${val}`;

  const match = str.match(regex6);

  if (match == null) {
    return val;
  }

  let len = match[0].length - 1;

  // e.g. 1.0000000000000001e-24
  if (str.indexOf('e-') !== -1) {
    let [num, exp] = str.split('e');
    return +`${fixFloat(num as unknown as number)}e${exp}`;
  }

  return roundDec(val, len);
};
// https://stackoverflow.com/a/48764436
// rounds half away from zero
export function roundDec(val: number, dec = 0) {
  if (Number.isInteger(val)) {
    return val;
  }
  //	else if (dec == 0)
  //		return round(val);

  let p = 10 ** dec;
  let n = val * p * (1 + Number.EPSILON);
  return Math.round(n) / p;
}

export function incrRoundUp(
  num: number,
  incr: number,
  _fixFloat: boolean = true
) {
  return _fixFloat
    ? fixFloat(ceil(fixFloat(num / incr)) * incr)
    : ceil(num / incr) * incr;
}
